import { makeVar } from '@apollo/client';
import {
  DocketUpdate,
  AllDayViewItem,
  StatsBarUpdate,
  DocketDisplayOrder,
} from '../common/types';
import { Session } from './preferences';
import BackgroundWorker from '../workers/BackgroundWorker';
import { PaginatedDocketItems } from '../utils/layoutHelper';

export const docketsUpdated = makeVar<DocketUpdate>({ timestamp: 0 });
export const netWorkStatus = makeVar<boolean>(false);
export const tokenUpdated = makeVar<{ timestamp: number }>({ timestamp: 0 });
export const tokenState = makeVar<
  Pick<Session, 'token' | 'expiredDate' | 'refreshToken'>
>({});

export const openDocketslastUpdatedAt = makeVar<number>(0);

export const docketsLastMovedAt = makeVar<number>(0);
export const docketMoving = makeVar<boolean>(false);

export const allDayViewItemsVar = makeVar<AllDayViewItem[]>([]);
export const allDayViewHighlightedItemsVar = makeVar<string[]>([]);
export const docketsCategoriesCount = makeVar<Record<string, number> | {}>({});

export const prevDocketItemsStateVar = makeVar<PaginatedDocketItems[]>([]);

export const workerInstanceVar = makeVar<BackgroundWorker | undefined>(
  undefined,
);

export const bulkSelectVar = makeVar<boolean>(false);
export const selectedDocketVar = makeVar<Record<string, DocketDisplayOrder>>(
  {},
);

export const timeVar = makeVar<number>(Date.now());
export const statsBarUpdated = makeVar<StatsBarUpdate>({
  lastUpdatedAt: 0,
});

export const rushedVar = makeVar('');

// Feature flags
export const autoBumpFeatureVar = makeVar(false);
